import { format } from 'libs';
import Number from './Number';
import type { ComponentProps } from 'react';

type PercentageProps = Omit<ComponentProps<typeof Number>, 'formatter'>;

const Percentage = ({ ref, ...props }: PercentageProps) => (
  <Number {...props} formatter={format.percentage} ref={ref} />
);

export default Percentage;
